/** 单个附件 */
export class HdAccessoryFile {
  /** 展示文件名 */
  name?: string;
  /** 完整下载/查看地址（由父组件直接传入） */
  path?: string;
  /** 文件大小（可缺省；有值才展示）：数字按字节格式化，字符串原样展示 */
  size?: number | string;
}

/** 附件分组：标签 + 附件列表 */
export class HdAccessoryGroup {
  /** 分组标签，如「营业执照扫描件」 */
  name: string;
  /** 该分组下的附件 */
  accessoryList: Array<HdAccessoryFile> = [];
}
